// eslint-disable-next-line max-classes-per-file
import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {DefaultRegistrationNew} from './DefaultRegistrationNew';
import FastRegistrationPromocode from 'app/components/auth/FastRegistrationPromocode';
import FastRegistrationTerms from 'app/components/auth/FastRegistrationTerms';
import {configStore} from 'app/store/global';
import {observer} from 'mobx-react';

@observer
class FastRegistrationWithEmailContent extends DefaultRegistrationNew {
    static LEAD_FIELDS = ['password', 'email'];

    static METHOD = 'fast';

    render(): ReactNode {
        return this.state.success
            ? <div>{this.state.success}</div>
            : <form id="fast-sign-up" onSubmit={this.signUp} ref={this.rootForm}
                className="form-popup popup-form--error" autoComplete="new-password">
                <span className="form-title">{I18n.t('register')}</span>
                <div className="fast-registration-with-email">
                    <input
                        name="site_lang"
                        type="hidden"
                        value={configStore.CONFIG?.lang}
                    />
                    <input name="full_registered" type="hidden" value="0"/>
                    {this.rowName()}
                    {this.rowEmail()}
                    {this.rowPassword(true)}
                    {this.rowCountryCode()}
                    {this.rowCaptcha()}
                    <FastRegistrationPromocode/>
                    <FastRegistrationTerms/>
                    <div className="popup-form__submit-row">
                        {this.renderRegisterButton(I18n.t('chek_up'))}
                    </div>
                </div>
            </form>;
    }
}

export default withGoogleReCaptcha(FastRegistrationWithEmailContent);
